import { Tooltip } from "@mantine/core";

export const tooltipComponentSettings = Tooltip.extend({
  defaultProps: {
    color: "gray.7",
    withArrow: true,
    zIndex: `calc(var(--app-shell-header-z-index) - 1)`,
  },
  styles: {
    tooltip: {
      padding: 8,
    },
  },
});
